<div class="m-5">
    <h2 class="text-xl font-semibold mb-2">Delete {{ data.product.product }}</h2>

    <!-- Checking where the product is used -->
    <div *ngIf="usageLoading" class="flex items-center gap-x-2 my-8 text-sm text-gray-500">
        <mat-spinner mode="indeterminate" [diameter]="20"></mat-spinner>
        <span>Checking where this product is used...</span>
    </div>

    <!-- Usage couldn't be loaded -->
    <p *ngIf="!usageLoading && !usage" class="my-8 text-sm text-red-600">
        We couldn't check where this product is used, so it can't be deleted right now. Please close this and try
        again.
    </p>

    <!-- Not used anywhere: permanently delete -->
    <ng-container *ngIf="canDelete">
        <p class="text-red-600 font-medium text-lg">
            This product isn't used anywhere, so it will be permanently deleted. This can't be undone.
        </p>

        <div class="relative flex items-start my-8">
            <div class="flex h-6 items-center">
                <input id="confirmDeleteProduct" type="checkbox"
                    class="h-4 w-4 rounded border-gray-300 text-red-600 focus:ring-red-600"
                    [formControl]="confirmation" />
            </div>
            <div class="ml-3 text-sm leading-6">
                <label for="confirmDeleteProduct" class="font-medium text-gray-900">
                    I understand this product will be permanently deleted.
                </label>
            </div>
        </div>
    </ng-container>

    <!-- In use: archive instead -->
    <div *ngIf="canArchive" class="my-6 space-y-3 text-sm text-gray-700">
        <p>
            This product is used in {{ usageSummary }}, so it can't be deleted. It will be
            <span class="font-semibold">archived</span> instead.
        </p>
        <p>
            Archived products are hidden from the Products list, the audit specification product picker and the
            inspector app. Existing inspections and reports aren't affected, and you can restore the product at any
            time.
        </p>
    </div>

    <!-- Already archived and still in use -->
    <p *ngIf="usage?.total > 0 && data.product.archived" class="my-6 text-sm text-gray-700">
        This product is already archived. It's still used in {{ usageSummary }}, so it can't be permanently deleted.
    </p>

    <div class="flex flex-row justify-between">
        <button type="button" [mat-dialog-close] [disabled]="loading"
            class="px-3 py-1 text-sm leading-6 text-gray-900 hover:bg-gray-100 flex flex-row items-center justify-center rounded-md border border-gray-900 disabled:cursor-not-allowed disabled:opacity-60">
            {{ usageLoading || canDelete || canArchive ? 'Cancel' : 'Close' }}
        </button>
        <div class="spacer"></div>
        <mat-spinner mode="indeterminate" [diameter]="30" class="mr-3" *ngIf="loading"></mat-spinner>

        <button *ngIf="canDelete" type="button" (click)="deleteProduct()" [disabled]="!confirmation.value || loading"
            class="flex items-center gap-x-1 rounded-md bg-red-600 px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-red-600">
            <ng-icon name="heroTrash" size="18"></ng-icon>
            <span>Delete product</span>
        </button>

        <button *ngIf="canArchive" type="button" (click)="archiveProduct()" [disabled]="loading"
            class="flex items-center gap-x-1 rounded-md bg-cg-primary px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:bg-cg-primary">
            <ng-icon name="heroArchiveBox" size="18"></ng-icon>
            <span>Archive product</span>
        </button>
    </div>
</div>
